<template>
  <div id="chat-nav">
    <div>
      <slot name="prefix">
        <img v-if="true||user.avatar" src="@/assets/user.png" @click="toExit" :alt="user.name" class="avatar" />
        <div v-else class="avatar" @click="toExit">{{user.name&&user.name.slice(-2)}}</div>
      </slot>
    </div>
    <div class="title">
      <slot></slot>
    </div>
    <div>
      <slot name="suffix"></slot>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user") || "{}")
    };
  },
  methods: {
    toExit() {
      console.log("log exit:");
      this.$confirm("确认退出么？", { type: "warning" })
        .then(res => {
          // console.log("log exit");
          localStorage.clear();
          this.$router.push({ name: "login" });
        })
        .catch(() => {
          console.log("log catch:");
        });
    }
  }
};
</script>
<style lang="scss" scoped>
#chat-nav {
  height: 44px;
  padding: 0 30px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: hsla(0, 0%, 95%, 1);
  .avatar {
    width: 30px;
    height: 30px;
    object-fit: contain;
    border-radius: 15px;
    // border: 1px dashed;
    // color: hsla(0, 0%, 0%, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
  }
  .title {
    color: hsla(0, 0%, 0%, 1);
    font-weight: 500;
    font-size: 17px;
  }
}
@media screen and (max-width: 750px) {
  #chat-nav {
    padding: 0 15px;
  }
}
</style>